// team-pack-submodule-manager.ts
//
// v3: team-ai-pack KHÔNG còn là git submodule. Pack tải qua tarball từ Supabase
// Edge Function get-pack (xem supabase-pack-downloader.ts). File này giữ tên +
// các export cũ (6+ file import gián tiếp) nhưng ruột đổi sang tarball.
//
// Lịch sử: trước v3 dùng git submodule + GitHub access check. Cắt hẳn ở v3 —
// auth chuyển sang Supabase id_token (login NAL), user không cần GitHub access pack.
import { join } from "node:path";
import { readPackVersionFromFile, writePackManifest } from "./pack-manifest-store.js";
import { downloadAndExtractPack, fetchSignedPackUrl } from "./supabase-pack-downloader.js";
import { getValidIdToken } from "./user-config-store.js";

// GIỮ export — 6+ file import path này (init-success, scaffold, init-flow, sync, status, pack-status).
export const TEAM_PACK_RELATIVE_PATH = ".claude/pack";

// GIỮ export — init.ts catch để exit 0 graceful khi user abort.
export class TeamPackAccessAbortedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "TeamPackAccessAbortedError";
  }
}

// Install team-ai-pack vào project qua tarball Supabase.
// Tên giữ "addTeamPackSubmodule" vì caller cũ import; ruột là tải tarball.
//
// version undefined → server trả stable mới nhất (stable/latest.txt).
// version cụ thể (vd v0.2.0-beta.0) → pin bản đó.
// Trả { pinnedTag } = version đã cài (cho caller in ra).
export async function addTeamPackSubmodule(
  projectRoot: string,
  version?: string,
): Promise<{ pinnedTag: string | null }> {
  const idToken = await getValidIdToken();
  const info = await fetchSignedPackUrl(idToken, version);

  const packDir = join(projectRoot, TEAM_PACK_RELATIVE_PATH);
  await downloadAndExtractPack(info.url, packDir, info.sha256);

  // version cài được = từ object name (pack-vX.Y.Z.tar.gz) hoặc version pin.
  const installedVersion = version ?? objectToVersion(info.object);
  await writePackManifest(packDir, {
    version: installedVersion,
    downloadedObject: info.object,
    extractedAt: new Date().toISOString(),
  });

  return { pinnedTag: installedVersion };
}

// "pack-v0.2.0.tar.gz" → "v0.2.0"
function objectToVersion(object: string): string {
  return object.replace(/^pack-/, "").replace(/\.tar\.gz$/, "");
}

// Đọc version pack đang cài. v3: đọc từ manifest (.avatar-pack-manifest.json) thay
// vì git tag. GIỮ tên export — status.ts + pack-status-and-version-check.ts import.
export async function readPinnedPackVersion(projectRoot: string): Promise<string> {
  const packDir = join(projectRoot, TEAM_PACK_RELATIVE_PATH);
  const version = await readPackVersionFromFile(packDir);
  return version ?? "(unknown)";
}
